/**
 * Extracts the Retry-After value (in seconds) from an Axios error response.
 * Supports both integer-seconds and HTTP-date formats per RFC 7231.
 * Returns null if the header is absent or unparseable.
 */
export function extractRetryAfter(error: unknown): number | null {
  const headers = (error as { response?: { headers?: Record<string, string> } })?.response?.headers
  if (!headers) return null

  const raw = headers['retry-after'] ?? headers['Retry-After']
  if (!raw) return null

  // Integer seconds
  const asInt = parseInt(raw, 10)
  if (!isNaN(asInt) && asInt > 0) return asInt

  // HTTP-date format
  const date = new Date(raw)
  if (!isNaN(date.getTime())) {
    const seconds = Math.ceil((date.getTime() - Date.now()) / 1000)
    return seconds > 0 ? seconds : null
  }

  return null
}
